/* ---------------------------------------------------------------------------
   Bottega d'Arte Stringa — "Aggiungi" senza ricaricare, e il cassetto che
   mostra il carrello vero.

   Nell'anteprima il cassetto mostrava UNA riga sola, riempita da openCart con
   l'ultimo pezzo aggiunto: non si vedeva cosa c'era nel carrello. Qui dopo
   ogni aggiunta si rilegge /cart.js e si ridisegna la lista intera — foto,
   nome, quantita' e prezzo di ogni articolo — poi si apre il cassetto.

   openCart non si chiama piu': scriveva in elementi (#cartDrawerName,
   #cartDrawerImg...) che la lista ha sostituito.
   --------------------------------------------------------------------------- */
(function () {
  "use strict";

  // Il negozio scrive "€98,00", non "98,00 €": il formato italiano di
  // toLocaleString mette il simbolo in coda, e nel cassetto stonava rispetto
  // al resto del sito.
  function euro(centesimi) {
    var n = (centesimi / 100).toFixed(2).split(".");
    var intera = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return "€" + intera + "," + n[1];
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  // una miniatura piu' piccola della stessa foto, invece dell'originale intera
  function foto(url, larghezza) {
    if (!url) return "";
    return url.indexOf("?") > -1
      ? url.replace(/([?&])width=\d+/, "$1width=" + larghezza) + (/width=/.test(url) ? "" : "&width=" + larghezza)
      : url + "?width=" + larghezza;
  }

  function disegnaLista(carrello) {
    var lista = document.getElementById("cartDrawerLista");
    if (!lista) return;
    if (!carrello.items.length) {
      lista.innerHTML = '<div class="cart-drawer-vuoto">Il carrello &egrave; vuoto.</div>';
      return;
    }
    lista.innerHTML = carrello.items.map(function (i) {
      var img = i.image
        ? '<img src="' + esc(foto(i.image, 200)) + '" alt="' + esc(i.product_title) + '" width="200" height="200">'
        : '<span class="cdx-senza-foto" aria-hidden="true"></span>';
      var variante = (i.variant_title && i.variant_title !== "Default Title")
        ? esc(i.variant_title) + " &middot; " : "";
      var marchio = i.vendor ? '<div class="cdi-brand">' + esc(i.vendor) + "</div>" : "";
      var scontato = i.original_line_price > i.final_line_price
        ? '<span class="cdi-old">' + euro(i.original_line_price) + "</span>" : "";
      return '<div class="cart-drawer-item">' +
        '<a href="' + esc(i.url) + '">' + img + "</a>" +
        "<div>" + marchio +
          '<div class="cn"><a href="' + esc(i.url) + '">' + esc(i.product_title) + "</a></div>" +
          '<div class="cdi-desc">' + variante + "Quantit&agrave;: " + i.quantity + "</div>" +
          '<div class="cp">' + scontato + "<span>" + euro(i.final_line_price) + "</span></div>" +
        "</div></div>";
    }).join("");
  }

  function aggiornaConteggio(n) {
    var c = document.getElementById("cartCount");
    if (c) c.textContent = n;
  }

  function apriCassetto() {
    var d = document.getElementById("cartDrawer");
    var o = document.getElementById("cartDrawerOverlay");
    if (d) d.classList.add("open");
    if (o) o.classList.add("open");
  }

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf("/cart/add") === -1) return;
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var etichetta = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = "Aggiungo…"; }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error("carrello");
        // no-store: senza, il conteggio puo' arrivare da una risposta in cache
        return fetch("/cart.js", { headers: { Accept: "application/json" }, cache: "no-store" });
      })
      .then(function (r) { return r.json(); })
      .then(function (carrello) {
        if (btn) { btn.disabled = false; btn.textContent = etichetta; }
        aggiornaConteggio(carrello.item_count);
        if (document.getElementById("cartDrawerLista")) {
          disegnaLista(carrello);
          apriCassetto();
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        // se qualcosa va storto non si perde l'articolo: si passa dal carrello vero
        form.submit();
      });
  });
})();
